<script>
import moment from "moment";
import InboxService from "@/helpers/APIService/inbox.service";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import Middleware from "@/helpers/middlewares";
import MultiSelect from "vue-multiselect";

export default {
  props: {
    currentProps: Object,
  },
  data() {
    return {
      emailData: [],
      isShowOption: false,
      allSelected: [],
      chatUserList: [],
      selectedData: null,
      chatTagOptions: [],
      newPersona: "",
      profile: { tags: [], id: null },
      allDataSelect: false,
      isStillLoading: true,
    };
  },
  components: { MultiSelect },
  computed: {
    ...authComputed,
  },
  watch: {
    emailData(newer, older) {
      if (newer != older) {
        for (let index = 0; index < this.emailData.length; index++) {
          this.emailData[index].isRead = false;
          this.selectedData = null;
          this.allSelected = [];
        }
      }
    },
  },
  mounted() {
    if (localStorage.thisChatData) {
      this.chatTagOptions = JSON.parse(localStorage.getItem("thisChatData"));
    }
    this.emailData = this.currentProps.chatData;
    this.chatUserList = this.currentProps.chatUsers;
    this.$root.$on("chatData", (data) => {
      this.emailData = data;
      this.isStillLoading = false;
    });
    this.$root.$on("chatUsers", (data) => {
      this.chatUserList = data;
    });
    this.$root.$on("chatTagOptions", (data) => {
      this.chatTagOptions = data;
    });
  },
  methods: {
    emailSelect(email) {
      if (email != undefined && email != null && email != "") {
        this.$root.$emit("onEmailSelect", { email, isRead: true });
      }
    },
    showOptionHandle(data) {
      this.profile.tags = [];
      data.group_tags.map((item) => {
        this.profile.tags.push(
          this.chatTagOptions.find((tagItem) => tagItem.value == item)
        );
      });
      this.selectedData = data;
      if (data.isRead) {
        this.isShowOption = true;
        this.allSelected.push(data);
      }
      if (!data.isRead) {
        this.allSelected.map((item) => {
          if (item.id == data.id) {
            const index = this.allSelected.indexOf(item);
            this.allSelected.splice(index, 1);
          }
        });
      }
      if (this.allSelected.length == 0) {
        this.isShowOption = false;
      }
    },
    markAsReadAll() {
      this.allSelected.map((item) => {
        InboxService.getInboxChatGroup(item.id);
        item.unread_message = 0;
      });
      for (let index = 0; index < this.emailData.length; index++) {
        this.emailData[index].isRead = false;
        this.selectedData = null;
        this.allSelected = [];
      }
      Middleware.notification("Marked as read !!", "success", 1500);
    },
    followAll() {
      this.allSelected.map((item) => {
        this.followMultiGroup(item);
      });
      for (let index = 0; index < this.emailData.length; index++) {
        this.emailData[index].isRead = false;
        this.selectedData = null;
        this.allSelected = [];
      }
      Middleware.notification("Added to favorites !!", "success", 2000);
    },
    addTagToAll() {
      this.allSelected.map((item) => {
        this.profile.id = item.id;
      });
    },
    convertDateOrTime(dateTime) {
      return moment(dateTime).fromNow();
    },
    refresh() {
      this.isStillLoading = true;
      this.$root.$emit("relaodPage");
    },
    async followMultiGroup(data) {
      try {
        const response = await InboxService.followInboxGroup(data.id);
        if (response) {
          data.group_followers = response.group_followers;
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    async followGroup(data) {
      if (
        data.group_followers.length != 0 &&
        data.group_followers.includes(this.user.user.id)
      ) {
        try {
          const response = await InboxService.unfollowInboxGroup(data.id);
          if (response) {
            data.group_followers = response.group_followers;
            Middleware.notification(
              "Removed from favorites !!",
              "success",
              1500
            );
          }
        } catch (error) {
          errorHandler(error);
        }
      } else {
        try {
          const response = await InboxService.followInboxGroup(data.id);
          if (response) {
            data.group_followers = response.group_followers;
            Middleware.notification("Added to favorites !!", "success", 1500);
          }
        } catch (error) {
          errorHandler(error);
        }
      }
    },
    async updateTags() {
      let tagUpdate = "";
      tagUpdate = {
        group_tags: this.profile.tags.map((tag) => {
          return tag.value;
        }),
      };
      const response = await InboxService.editInboxGroups(
        this.profile.id,
        tagUpdate
      );
      if (response) {
        this.emailData.map((item) => {
          if (item.id == this.profile.id) {
            item.group_tags = response.group_tags;
          }
        });
        Middleware.notification("Successfully updated !!", "success");
      }
    },
    toSelectAll() {
      this.allDataSelect = true;
    },
  },
};
</script>

<template>
  <div class="card mb-0">
    <div class="p-3">
      <b-tabs justified nav-class="nav-tabs-custom" content-class="pt-3">
        <b-tab active>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">Inbox </span>
          </template>
          <div class="email-rightbar">
            <div class="btn-toolbar d-flex align-items-center px-3 mb-2">
              <div class="message-list me-1">
                <div class="checkbox-wrapper-mail">
                  <input
                    id="chk_all"
                    v-model="allDataSelect"
                    @click="toSelectAll()"
                    type="checkbox"
                  />
                  <label for="chk-all"></label>
                </div>
              </div>
              <div class="btn-group-icon d-flex align-items-center">
                <i
                  v-if="!isStillLoading"
                  @click="refresh()"
                  class="mdi mdi-refresh icon fs-4"
                  v-b-popover.hover.bottom="'Refresh'"
                ></i>
                <div class="col-mail-11 me-2">
                  <div
                    class="d-flex align-items-center"
                    v-if="
                      isShowOption && selectedData && !selectedData.personal
                    "
                  >
                    <i
                      class="mdi mdi-check icon fs-4"
                      v-b-popover.hover.top="'Mark as a closed'"
                    ></i>
                    <i
                      @click="markAsReadAll()"
                      class="mdi mdi-email-open-outline icon fs-4"
                      v-b-popover.hover.top="'Mark as a read'"
                    ></i>
                    <i
                      class="mdi mdi-email-outline icon fs-4"
                      v-b-popover.hover.top="'Mark as a unread'"
                    ></i>

                    <b-dropdown
                      menu-class="dropdown-menu-md dropdown-menu-end p-0"
                      variant="white"
                      right
                      toggle-class="nav-btn p-0"
                    >
                      <template v-slot:button-content>
                        <i
                          class="mdi mdi-clock-outline icon fs-4"
                          v-b-popover.hover.top="'Snooze'"
                        ></i>
                      </template>
                      <div class="p-2">
                        <ul class="p-0">
                          <li
                            class="snooze-list-item d-flex justify-content-between cursor"
                          >
                            <h6 class="mb-0">Later Today</h6>
                            <p class="mb-0">In 3 hour</p>
                          </li>
                          <li
                            class="snooze-list-item d-flex justify-content-between cursor"
                          >
                            <h6 class="mb-0">Tomorrow</h6>
                            <p class="mb-0">Sat 9 am</p>
                          </li>
                          <li
                            class="snooze-list-item d-flex justify-content-between cursor"
                          >
                            <h6 class="mb-0">Next Monday</h6>
                            <p class="mb-0">9 am</p>
                          </li>
                          <li
                            class="snooze-list-item d-flex justify-content-between cursor"
                          >
                            <h6 class="mb-0">One Week</h6>
                            <p class="mb-0">Fri 7 pm</p>
                          </li>
                          <li
                            class="snooze-list-item d-flex justify-content-between cursor"
                          >
                            <h6 class="mb-0">One month</h6>
                            <p class="mb-0">10 Mar</p>
                          </li>
                          <li
                            class="snooze-list-item d-flex justify-content-between cursor"
                          >
                            <h6 class="mb-0">Pick date & time</h6>
                          </li>
                        </ul>
                      </div>
                    </b-dropdown>
                    <i
                      class="mdi mdi-delete-outline icon fs-4"
                      v-b-popover.hover.top="'Delete'"
                    ></i>
                    <i
                      class="mdi mdi-alert-octagon-outline icon fs-4"
                      v-b-popover.hover.top="'Report spam'"
                    ></i>
                    <i
                      @click="followAll()"
                      class="mdi mdi mdi-star-outline icon fs-4"
                      v-b-popover.hover.top="'Favourite'"
                    ></i>
                    <b-dropdown
                      menu-class="dropdown-menu-lg dropdown-menu-end p-0"
                      variant="white"
                      right
                      toggle-class="nav-btn p-0"
                    >
                      <template v-slot:button-content>
                        <i
                          v-if="allSelected.length == 1"
                          @click="addTagToAll($event)"
                          class="mdi mdi-tag-outline icon fs-4"
                          v-b-popover.hover.top="'Tag'"
                        ></i>
                      </template>
                      <div class="p-3">
                        <form class="mb-2">
                          <div class="form-group m-0">
                            <div class="input-group">
                              <MultiSelect
                                class="my-1"
                                v-model="profile.tags"
                                :options="chatTagOptions"
                                placeholder="Select/Add tag"
                                label="name"
                                track-by="value"
                                :show-labels="false"
                                :multiple="true"
                              ></MultiSelect>
                            </div>
                            <b-button
                              class="float-end mt-1"
                              variant="outline-primary"
                              @click="updateTags()"
                            >
                              <!-- <i
                                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                              ></i> -->
                              Update
                            </b-button>
                          </div>
                        </form>
                        <label>Edit Tags</label>
                        <div class="d-flex py-1 px-2">
                          <i class="mdi mdi-tag-outline fs-4"></i>
                          <p class="ms-2 mb-0">New Tag</p>
                        </div>
                        <div class="d-flex py-1 px-2">
                          <i class="dripicons-tag-delete fs-4"></i>
                          <p class="ms-2 mb-0">Clear Tags</p>
                        </div>
                      </div>
                    </b-dropdown>
                    <i
                      class="mdi mdi-merge icon fs-4"
                      v-b-popover.hover.top="'Merge Conversation'"
                    ></i>
                    <i
                      class="mdi mdi-arrow-right icon fs-4"
                      v-b-popover.hover.top="'Move to folder'"
                    ></i>

                    <b-dropdown
                      menu-class="dropdown-menu-lg dropdown-menu-end p-0"
                      variant="white"
                      right
                      toggle-class="nav-btn p-0"
                    >
                      <template v-slot:button-content>
                        <b-button
                          type="submit"
                          class="btn-sm rounded-pill"
                          variant="outline-secondary"
                        >
                          Assign
                        </b-button>
                      </template>
                      <div class="p-3">
                        <form class="mb-2">
                          <div class="form-group m-0">
                            <div class="input-group">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Search Users."
                                aria-label=""
                              />
                              <div class="input-group-append">
                                <button class="btn btn-primary" type="submit">
                                  <i class="mdi mdi-magnify"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                        <div class="d-flex align-items-center my-3">
                          <div class="avatar-xs align-self-center me-3">
                            <span
                              class="avatar-title rounded-circle bg-soft bg-primary text-primary"
                              ><i class="bx bx-user fs-4"></i
                            ></span>
                          </div>
                          <h5 class="mb-0 font-size-16">Unassigned</h5>
                        </div>
                        <div class="d-flex align-items-center my-3">
                          <div class="avatar-xs align-self-center me-3">
                            <span
                              class="avatar-title rounded-circle bg-soft bg-primary text-primary"
                              ><i class="bx bx-user fs-4"></i
                            ></span>
                          </div>
                          <h5 class="mb-0 font-size-16">Me</h5>
                        </div>
                      </div>
                    </b-dropdown>
                  </div>
                </div>
              </div>
              <h6 class="mb-0">
                Last Message
                <i class="fa fa-info-circle mb-0 ms-1" id="popover-3"> </i>
                <b-popover target="popover-3" triggers="hover focus">
                  <template #title>Message Types</template>
                  <div class="p-2">
                    <div class="d-inline-flex">
                      <i class="bx bx-chat text-danger fs-5 me-2"> </i>
                      <span> Internal Note</span>
                    </div>
                    <br />
                    <div class="d-inline-flex">
                      <i
                        class="mdi mdi-message-processing-outline text-primary fs-5 me-2"
                      ></i>
                      <span> SMS</span>
                    </div>
                    <br />
                    <div class="d-inline-flex">
                      <i class="fab fa-whatsapp text-success fs-5 me-2"> </i>
                      <span> Whatsapp Message</span>
                    </div>
                    <!-- <i class="fas fa-people-arrows text-warning fs-6 mt-2 me-2">
                    </i>
                    <span> Lobby Agents PM</span>
                    <br /> -->
                    <!-- <p class="mb-0">
                      - Room no. <span class="text-success">Green</span> (Lock
                      Online)
                    </p>
                    <p class="mb-0">
                      - Room no. <span class="text-danger">Red</span> (Lock
                      Offline)
                    </p> -->
                  </div>
                </b-popover>
              </h6>
              <!-- <h6 class="date-msg mb-0">Date-time</h6> -->
              <h6 class="date-msg mb-0 ms-auto">
                <b-dropdown
                  menu-class="dropdown-menu-lg dropdown-menu-end"
                  variant="white"
                  right
                  toggle-class="nav-btn"
                >
                  <template v-slot:button-content>
                    <i
                      class="bx bx-plus fs-3"
                      v-b-popover.hover.bottom="'New Chat'"
                    ></i>
                  </template>
                  <form class="p-3">
                    <label>Message to</label>
                    <MultiSelect
                      class="my-1"
                      v-model="newPersona"
                      :options="chatUserList"
                      placeholder="Select User"
                      label="name"
                      track-by="id"
                      :show-labels="false"
                      @close="emailSelect(newPersona)"
                    ></MultiSelect>
                  </form>
                </b-dropdown>
              </h6>
            </div>
            <ul
              v-if="isStillLoading"
              class="message-list message-list-scrollbar"
            >
              <div v-for="item in 10" :key="item">
                <li
                  class="placeholder-glow d-flex align-items-center py-1 px-3"
                >
                  <span
                    class="placeholder w-100 placeholder checkbox-wrapper-mail"
                    v-for="no in 3"
                    :key="no"
                    style="height: 35px"
                  ></span>
                </li>
              </div>
            </ul>
            <ul v-else class="message-list message-list-scrollbar">
              <div v-for="(data, index) in emailData" :key="index">
                <li v-if="data" class="d-flex align-items-center py-1 px-3">
                  <div class="me-xl-3 me-lg-2">
                    <div class="checkbox-wrapper-mail" v-if="!data.personal">
                      <input
                        :id="`chk-${index}`"
                        type="checkbox"
                        v-model="data.isRead"
                        @change="showOptionHandle(data)"
                      />
                      <label :for="`chk-${index}`"></label>
                    </div>
                    <div class="ms-5" v-else></div>
                    <i
                      v-if="!data.personal"
                      :class="{
                        'text-warning': data.group_followers.includes(
                          user.user.id
                        ),
                      }"
                      class="fas fa-star fs-5 ms-2"
                      @click="followGroup(data)"
                    ></i>
                  </div>
                  <div class="col-mail-11 me-2" @click="emailSelect(data)">
                    <div class="title d-flex align-items-center">
                      <img
                        v-if="data.group_avtar"
                        :src="data.group_avtar"
                        class="rounded-circle picture-img me-3"
                        alt="profile-photo"
                      />
                      <div
                        class="position-relative me-3"
                        v-else-if="data.profile_picture"
                      >
                        <img
                          :src="data.profile_picture"
                          class="rounded-circle picture-img"
                          alt="profile-photo"
                        />
                        <div class="profile-status-icon" v-if="data.personal">
                          <i
                            class="mdi mdi-circle align-middle me-1"
                            :class="
                              data.status && data.status == 'online'
                                ? 'text-success'
                                : 'text-danger'
                            "
                          ></i>
                        </div>
                      </div>
                      <div
                        class="position-relative me-lg-3 me-2"
                        v-else-if="
                          data.inbox_user && data.inbox_user.profile_picture
                        "
                      >
                        <img
                          :src="data.inbox_user.profile_picture"
                          class="rounded-circle picture-img"
                          alt="profile-photo"
                        />
                      </div>
                      <div
                        class="picture-img me-lg-3 me-2 position-relative"
                        v-else
                      >
                        <span
                          class="avatar-title rounded-circle bg-soft bg-primary text-primary text-uppercase"
                          >{{
                            data.personal
                              ? data.first_name.charAt(0)
                              : !data.personal && data.group_name != null
                              ? data.group_name.charAt(0)
                              : "c"
                          }}{{
                            data.personal
                              ? data.last_name.charAt(0)
                              : !data.personal && data.group_name != null
                              ? data.group_name.charAt(1)
                              : "c"
                          }}</span
                        >
                        <div class="profile-status-icon" v-if="data.personal">
                          <i
                            class="mdi mdi-circle align-middle me-1"
                            :class="
                              data.status && data.status == 'online'
                                ? 'text-success'
                                : 'text-danger'
                            "
                          ></i>
                        </div>
                      </div>
                      <div>
                        <span
                          >{{ data.name
                          }}{{
                            data.unread_message != 0
                              ? "(" + data.unread_message + ")"
                              : ""
                          }}
                        </span>
                        <div class="d-flex flex-wrap">
                          <div v-for="tag in data.group_tags" :key="tag">
                            <div
                              v-for="chat in chatTagOptions"
                              :key="chat.value"
                            >
                              <div v-if="chat.value == tag">
                                <div
                                  class="badge px-2 py-1 text-light rounded-pill cursor me-2"
                                  :style="{
                                    'background-color': [chat.color],
                                  }"
                                >
                                  {{ chat.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="me-2" @click="emailSelect(data)">
                    <div
                      class="col-mail-22 d-flex align-items-center"
                      v-if="data.last_inbox_message != null"
                    >
                      <i
                        v-if="data.last_inbox_message.msg_channel == 'sms'"
                        class="mdi mdi-message-processing-outline text-primary fs-3 me-2"
                      ></i>
                      <i
                        v-if="data.last_inbox_message.msg_channel == 'chat'"
                        class="bx bx-chat text-danger fs-3 me-2"
                      ></i>
                      <!-- <i
                        v-if="data.last_inbox_message.msg_channel == undefined"
                        class="fas fa-people-arrows text-warning fs-5 me-2"
                      ></i> -->
                      <span
                        class="text-truncate"
                        :class="data.unread_message != 0 ? 'fw-bold' : ''"
                        v-if="data.last_inbox_message.msg_content !== ''"
                      >
                        {{ data.last_inbox_message.msg_content }}
                      </span>
                      <span
                        class="text-truncate"
                        :class="data.unread_message != 0 ? 'fw-bold' : ''"
                        v-else-if="
                          data.last_inbox_message.msg_media_urls.length != 0
                        "
                      >
                        <i class="far fa-image"></i>
                        {{ "Photo" }}
                      </span>
                    </div>
                  </div>
                  <div
                    @click="emailSelect(data)"
                    class="date-time font-size-11"
                    v-if="
                      data.last_inbox_message &&
                      data.last_inbox_message.created_at
                    "
                  >
                    {{ convertDateOrTime(data.last_inbox_message.created_at) }}
                  </div>
                </li>
                <hr class="my-2" />
              </div>
            </ul>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
